

const DocumentPreview = ({ docs = [] }) => {
  return (
    <div>
     
      <div className="d-flex flex-wrap gap-3">
        {docs.map((d, i) => {
          const fileUrl = `${d.url}`;
          const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(d.filename);
          const isPdf = /\.pdf$/i.test(d.filename);

          return (
            <div key={i} className="text-center">
              <a href={fileUrl} target="_blank" rel="noreferrer">
                {isImage ? (
                  <img
                    src={fileUrl}
                    alt={d.filename}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      cursor: "pointer",
                    }}
                  />
                ) : isPdf ? (
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      background: "#f8f9fa",
                      cursor: "pointer",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    PDF
                  </div>
                ) : (
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      background: "#f1f1f1",
                      cursor: "pointer",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    FILE
                  </div>
                )}
              </a>
              <div style={{ fontSize: "12px", marginTop: "4px" }}>
                {d.filename.length > 10
                  ? d.filename.substring(0, 10) + "..."
                  : d.filename}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DocumentPreview;
